// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__ZeN-5","rows":"Monitor_rows__ZFKkc","boxes":"Monitor_boxes__KIHJm","attitude":"Monitor_attitude__ofLwE"};